<template>
    <div class="container py-4">
        <div class="row">
            <!-- Left: Profile Form -->
            <div class="col-md-8">
                <div class="card p-4">
                    <h5>👤 Thông tin cá nhân</h5>
                    <hr>
                    <form>
                        <div class="mb-3">
                            <label class="form-label">Họ và tên</label>
                            <input type="text" class="form-control" :value="userInfo.name" disabled>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Email</label>
                            <input type="email" class="form-control" :value="userInfo.email" disabled>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Gia Nhập</label>
                            <input type="text" class="form-control" :value="formatDate(userInfo.createdAt)" disabled>
                        </div>
                    </form>
                </div>
            </div>

            <!-- Right: User Card -->
            <div class="col-md-4">
                <div class="card text-center p-4">
                  <h5 class="mt-4">📊 Thống kê</h5>
                  <p class="text-muted mb-0"><strong>Số từ yêu thích:</strong> {{ favoritesCount }}</p>
                  <p class="text-muted"><strong>Số thẻ ghi nhớ đã tạo:</strong> {{ flashcardsCount }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import {isAuthenticated} from "../utils/auth";
import { auth, database } from '@/firebase'
import { ref as dbRef, get } from "firebase/database";

const userInfo = ref({ name: '', email: '', createdAt: '' });
const favoritesCount = ref(0);
const flashcardsCount = ref(0);

const formatDate = (iso) => {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('vi-VN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

const loadUserData = async () => {
  const uid = auth.currentUser?.uid;
  if (!isAuthenticated()) return;

  const userRef = dbRef(database, `users/${uid}`);
  const snapshot = await get(userRef);

  if (snapshot.exists()) {
    const data = snapshot.val();
    userInfo.value = {
      name: data.name || '',
      email: data.email || auth.currentUser.email || '',
      createdAt: data.createdAt || ''
    };

    favoritesCount.value = data.favorites ? Object.keys(data.favorites).length : 0;
    flashcardsCount.value = data.flashcards ? Object.keys(data.flashcards).length : 0;
  }
};

onMounted(() => {
  loadUserData()
});
</script>
